import { axios } from "~/plugins/request"
export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  getProvince({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/onlineOrder/findProvinceList', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  initOrderList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/onlineOrder/findTouristOrder', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  exportOrder({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/onlineOrder/exportTouristOrder',
        data: params,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
}